/* Klariq interactions on Dawn: scroll reveal, gallery (thumbs, swipe, hover zoom, pinch-zoom lightbox),
   mobile sticky add-to-cart, tap-to-play video. Everything is progressive: without JS the page is complete. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  document.documentElement.classList.add('kq-js');
  window.addEventListener('beforeprint', function () {
    document.querySelectorAll('.kq-pre').forEach(function (el) { el.classList.add('kq-in'); });
  });

  /* ---------- Animation 1: illustrative photos fade in once (≤250 ms). Text is never hidden. ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('[data-kq-fade]:not(.kq-in):not(.kq-pre)');
    if (!items.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kq-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });
    var vh = window.innerHeight;
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < vh) return; // on screen at load: shown as-is (protects LCP)
      el.classList.add('kq-pre');
      io.observe(el);
    });
  }

  /* ---------- Animation 2: model tabs, opacity swap ≤180 ms, no layout jump ---------- */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-kq-tabs]').forEach(function (sec) {
      if (sec.dataset.kqReady) return;
      sec.dataset.kqReady = '1';
      var tabs = Array.prototype.slice.call(sec.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
      if (tabs.length < 2) return;
      function select(i, focus) {
        tabs.forEach(function (t, n) {
          var on = n === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on) {
            panels[n].hidden = false;
            if (!reduce) { panels[n].classList.add('is-entering'); requestAnimationFrame(function () { requestAnimationFrame(function () { panels[n].classList.remove('is-entering'); }); }); }
          } else { panels[n].hidden = true; }
        });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () { select(n, false); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select((n + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select((n - 1 + tabs.length) % tabs.length, true); }
        });
      });
      select(0, false);
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    if (g.dataset.kqReady) return;
    g.dataset.kqReady = '1';
    var track = g.querySelector('.kq-gallery__main');
    var slides = Array.prototype.slice.call(g.querySelectorAll('.kq-gallery__slide'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('.kq-gallery__thumbs button'));
    var counter = g.querySelector('[data-kq-counter]');
    if (!track || !slides.length) return;
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    g.querySelectorAll('[data-kq-prev]').forEach(function (b) { b.addEventListener('click', function () { go(current - 1); }); });
    g.querySelectorAll('[data-kq-next]').forEach(function (b) { b.addEventListener('click', function () { go(current + 1); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    // Native swipe via scroll-snap; keep thumbs in sync with the visible slide.
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) setActive(i);
      });
    }, { passive: true });

    // Desktop hover zoom (transform only).
    if (finePointer) {
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (!img) return;
        s.classList.add('kq-zoomable');
        s.addEventListener('mousemove', function (e) {
          var r = s.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          s.classList.add('is-zoom');
        });
        s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
      });
    }

    // Lightbox with pinch / double-tap zoom.
    var box = g.querySelector('.kq-lightbox');
    if (box && typeof box.showModal === 'function') {
      var boxImg = box.querySelector('img');
      slides.forEach(function (s, n) {
        s.addEventListener('click', function () {
          var img = s.querySelector('img');
          boxImg.src = img.dataset.zoomSrc || img.currentSrc || img.src;
          boxImg.alt = img.alt;
          resetZoom();
          box.showModal();
          setActive(n);
        });
      });
      box.querySelector('[data-kq-close]').addEventListener('click', function () { box.close(); });
      box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
      var scale = 1, tx = 0, ty = 0, pts = {}, startDist = 0, startScale = 1, last = null, lastTap = 0;
      function apply() { boxImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
      function resetZoom() { scale = 1; tx = 0; ty = 0; apply(); }
      function dist() { var p = Object.keys(pts).map(function (k) { return pts[k]; }); return Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y); }
      boxImg.addEventListener('pointerdown', function (e) {
        boxImg.setPointerCapture(e.pointerId);
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var n = Object.keys(pts).length;
        if (n === 2) { startDist = dist(); startScale = scale; }
        if (n === 1) {
          last = { x: e.clientX, y: e.clientY };
          var now = Date.now();
          if (now - lastTap < 300) { scale = scale > 1 ? 1 : 2.5; if (scale === 1) { tx = 0; ty = 0; } apply(); }
          lastTap = now;
        }
      });
      boxImg.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId]) return;
        pts[e.pointerId] = { x: e.clientX, y: e.clientY };
        var n = Object.keys(pts).length;
        if (n === 2 && startDist) { scale = Math.max(1, Math.min(4, startScale * dist() / startDist)); apply(); }
        else if (n === 1 && scale > 1 && last) { tx += e.clientX - last.x; ty += e.clientY - last.y; last = { x: e.clientX, y: e.clientY }; apply(); }
      });
      function up(e) { delete pts[e.pointerId]; if (Object.keys(pts).length < 2) startDist = 0; if (scale <= 1) { tx = 0; ty = 0; apply(); } }
      boxImg.addEventListener('pointerup', up);
      boxImg.addEventListener('pointercancel', up);
      boxImg.addEventListener('wheel', function (e) { e.preventDefault(); scale = Math.max(1, Math.min(4, scale - e.deltaY * 0.002)); if (scale === 1) { tx = 0; ty = 0; } apply(); }, { passive: false });
    }
    setActive(0);
    // Off-screen slides sit to the side of the viewport, where native lazy-loading never fires: load them once the page is idle.
    function warm() { slides.forEach(function (s) { var im = s.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; }); }
    if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', function () { setTimeout(warm, 300); });
  }

  /* ---------- Mobile sticky add-to-cart ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-kq-sticky]');
    var main = document.querySelector('[data-kq-atc]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      bar.querySelectorAll('button, a').forEach(function (el) { el.tabIndex = past ? 0 : -1; });
    }).observe(main);
  }

  /* ---------- Add-to-cart feedback ---------- */
  function initAtc() {
    document.querySelectorAll('form[data-kq-product-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        document.querySelectorAll('[data-kq-atc], [data-kq-sticky] button').forEach(function (b) { b.classList.add('is-loading'); });
      });
    });
  }

  /* ---------- Tap-to-play video ---------- */
  function initVideo(root) {
    (root || document).querySelectorAll('[data-kq-video]').forEach(function (wrap) {
      if (wrap.dataset.kqReady) return;
      wrap.dataset.kqReady = '1';
      var btn = wrap.querySelector('.kq-video__play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var v = document.createElement('video');
        v.src = wrap.dataset.src;
        v.controls = true; v.playsInline = true; v.preload = 'auto';
        v.setAttribute('playsinline', '');
        if (wrap.dataset.poster) v.poster = wrap.dataset.poster;
        if (wrap.dataset.captions) {
          var t = document.createElement('track');
          t.kind = 'captions'; t.src = wrap.dataset.captions; t.srclang = wrap.dataset.lang || 'en';
          t.label = wrap.dataset.captionsLabel || 'Captions'; t.default = true;
          v.appendChild(t);
        }
        v.className = 'kq-video__el';
        wrap.querySelector('.kq-video__frame').replaceChildren(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        v.focus();
      });
    });
  }

  function init(root) {
    initReveal(root);
    initTabs(root);
    (root || document).querySelectorAll('[data-kq-gallery]').forEach(initGallery);
    initVideo(root);
  }
  function initHeader() {
    var h = document.querySelector('.kq-header'); if (!h) return;
    var on = false;
    function check() { var s = window.scrollY > 4; if (s !== on) { on = s; h.classList.toggle('is-scrolled', s); } }
    window.addEventListener('scroll', check, { passive: true }); check();
  }
  function boot() { init(); initSticky(); initAtc(); initHeader(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor: re-run when a section is added or changed.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
